"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wwwUrl = wwwUrl;
exports.stayUrl = stayUrl;
exports.stayAmpUrl = stayAmpUrl;
exports.dashboardUrl = dashboardUrl;
exports.accountUrl = accountUrl;
exports.eventUrl = eventUrl;
exports.workUrl = workUrl;
exports.googleMapUrl = googleMapUrl;
exports.helpUrl = helpUrl;
exports.helpPaymentUrl = helpPaymentUrl;
exports.helpBillingUrl = helpBillingUrl;
exports.businessBaseUrl = businessBaseUrl;
exports.businessUrl = businessUrl;
exports.businessSummaryUrl = businessSummaryUrl;
exports.isCurrentPage = isCurrentPage;
exports.accountLoginUrl = accountLoginUrl;
exports.accountLogoutUrl = accountLogoutUrl;
exports.accountSignUpUrl = accountSignUpUrl;
exports.Host = void 0;

var _map = _interopRequireDefault(require("../constants/map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Host =
/*#__PURE__*/
function () {
  function Host() {
    _classCallCheck(this, Host);
  }

  _createClass(Host, null, [{
    key: "configureDefaultDev",
    value: function configureDefaultDev() {
      Host.rental = 'https://sandbox.spacemarket.com';
      Host.stay = 'https://stay-sandbox.spacemarket.com';
      Host.stayAmp = 'https://amp-stay-sandbox.spacemarket.com';
      Host.dashboard = 'https://dashboard-sandbox.spacemarket.com';
      Host.business = 'https://business-sandbox.spacemarket.com';
      Host.account = 'https://account-sandbox.spacemarket.com';
      Host.event = 'https://event-sandbox.spacemarket.com';
      Host.work = 'https://work-sandbox.spacemarket.com';
    }
  }, {
    key: "configure",
    value: function configure(config, dev) {
      if (dev) {
        Host.configureDefaultDev();
      }

      if (config.SPM_RENTAL_HOST) {
        Host.rental = config.SPM_RENTAL_HOST;
      }

      if (config.SPM_STAY_HOST) {
        Host.stay = config.SPM_STAY_HOST;
      }

      if (config.SPM_STAY_AMP_HOST) {
        Host.stayAmp = config.SPM_STAY_AMP_HOST;
      }

      if (config.SPM_DASHBOARD_HOST) {
        Host.dashboard = config.SPM_DASHBOARD_HOST;
      }

      if (config.SPM_BUSINESS_HOST) {
        Host.business = config.SPM_BUSINESS_HOST;
      }

      if (config.SPM_ACCOUNT_HOST) {
        Host.account = config.SPM_ACCOUNT_HOST;
      }

      if (config.SPM_EVENT_HOST) {
        Host.event = config.SPM_EVENT_HOST;
      }

      if (config.SPM_WORK_HOST) {
        Host.work = config.SPM_WORK_HOST;
      }
    }
  }]);

  return Host;
}();

exports.Host = Host;

_defineProperty(Host, "rental", 'https://www.spacemarket.com');

_defineProperty(Host, "stay", 'https://stay.spacemarket.com');

_defineProperty(Host, "stayAmp", 'https://amp-stay.spacemarket.com');

_defineProperty(Host, "dashboard", 'https://dashboard.spacemarket.com');

_defineProperty(Host, "business", 'https://business.spacemarket.com');

_defineProperty(Host, "account", 'https://account.spacemarket.com');

_defineProperty(Host, "event", 'https://event.spacemarket.com');

_defineProperty(Host, "work", 'https://work.spacemarket.com');

_defineProperty(Host, "help", 'https://help.spacemarket.com');

function wwwUrl(path) {
  return "".concat(Host.rental).concat(path);
}

function stayUrl(path) {
  return "".concat(Host.stay).concat(path);
}

function stayAmpUrl(path) {
  return "".concat(Host.stayAmp).concat(path);
}

function dashboardUrl(owner, path) {
  return "".concat(Host.dashboard, "/").concat(owner.username).concat(path);
}

function accountUrl(path, config) {
  var url = "".concat(Host.account).concat(path);

  if (config) {
    if (config.SPM_SERVICE_ID) {
      url = url + "?serviceId=".concat(config.SPM_SERVICE_ID);
    }

    if (config.URL) {
      var prefix = config.SPM_SERVICE_ID ? '&' : '?';
      var done = encodeURIComponent(config.URL);
      url = url + "".concat(prefix, "done=").concat(done);
    }
  }

  return url;
}

function eventUrl(path) {
  return "".concat(Host.event).concat(path);
}

function workUrl(path) {
  return "".concat(Host.work).concat(path);
}

function googleMapUrl(latitude, longitude, name) {
  return "https://www.google.com/maps?q=".concat(latitude || _map["default"].defaultLatitude, ",").concat(longitude || _map["default"].defaultLongitude, "+(").concat(encodeURIComponent(name || ''), ")");
}

function helpUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(Host.help, "/hc/ja/").concat(path);
}

function helpPaymentUrl() {
  return helpUrl('articles/217748737');
}

function helpBillingUrl() {
  return helpUrl('articles/218429038');
}

function businessBaseUrl() {
  return Host.business;
}

function businessUrl(path) {
  return "".concat(businessBaseUrl()).concat(path);
}

function businessSummaryUrl(username) {
  return "".concat(businessBaseUrl(), "/companies/").concat(username, "/summaries");
}

function isCurrentPage(path, pattern) {
  var regexp = new RegExp(pattern);
  return path.match(regexp);
}

function accountLoginUrl(config) {
  return accountUrl('/login', config);
}

function accountLogoutUrl(config) {
  return accountUrl('/logout', config);
}

function accountSignUpUrl(config) {
  return accountUrl('/sign_up', config);
}